export const labels = {
	mapStyleTitle: {
		label: "Label.MobileCreator.Maps.Dialog.Style",
		default: "Map style",
	},
} as const;
